export const PROPERTY_TYPE = {
    Condominium: "Condo",
    "Single Family Residential": "Single Family",
} as const;

export type PropertyTypeMap = typeof PROPERTY_TYPE;

const propertyTypeLang = { PROPERTY_TYPE };
export default propertyTypeLang;
